import { Component, Input } from "@angular/core";
import { KeeniconComponent } from "../keenicon/keenicon.component";

@Component({
  selector: "app-status-loading",
  templateUrl: "./status-loading.component.html",
  styleUrls: ["./status-loading.component.scss"],
  imports: [KeeniconComponent],
})
export class StatusLoadingComponent {
  @Input() isLoading = true;
  @Input() loadingClass = "min-h-80";
}
